import { TabPanel } from "devextreme-react";
import ActionBar, { Right } from "../../../core/components/actionbar/ActionBar";
import WatchLogList from "../component/watchlog/WatchLogList";
import { t } from "i18next";
import StatisticsList from "../component/watchlog/StatisticList";
import { useTabNavigation } from "../../../core/hook/useTabNaviagation";

interface WatchLogsProps {

}

export default function WatchLogs() {
    const tabs = [
        { id: 0, view: "summary", title: t("Summary"), component: <StatisticsList /> },
        { id: 1, view: "list", title: t("List"), component: <WatchLogList /> },
    ]

    const tabNavigation = useTabNavigation(tabs, "summary")

    return <>
        <ActionBar>
            <Right>
                <TabPanel
                    className="border-radius-small tabs"
                    height={"100%"}
                    selectedIndex={tabNavigation.selectedTab}
                    dataSource={tabs}
                    deferRendering
                    onSelectionChanged={tabNavigation.handleTabChange} />
            </Right>
        </ActionBar>
        {tabs[tabNavigation.selectedTab].component}
    </>

}
